<template>
  <v-app style="background-color: white" v-if="appUser">
    <RescueReport/>
  </v-app>
</template>
<script>
import RescueReport from "./RescueReport";
import store from "../../store";
export default {
  name: "Rescue",
  computed: {
    appUser() {
      return store.state.isLoggedIn;
    },
  },
  components: {
    RescueReport,
  },
};
</script>
